import Swiper from 'swiper/bundle';

export default class Carousel {
  constructor(element /*valeur passé par Main.j*/) {
    this.element = element;
    this.options = {
      slidesPerView: 5,
      spaceBetween: 2,

      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
      },

      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
    };
    this.init();
  }

  setOptions() {
    if ('split' in this.element.dataset) {
      this.options.breakpoints = {
        1600: {
          slidesPerView: 5,
          spaceBetween: 100,
        },

        1300: {
          slidesPerView: 4,
          spaceBetween: 75,
        },

        1000: {
          slidesPerView: 3,
          spaceBetween: 50,
        },

        700: {
          slidesPerView: 2,
          spaceBetween: 10,
        },

        300: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      };
    }

    if ('autoplay' in this.element.dataset) {
      this.options.autoplay = {
        delay: 3000, // delais entre défilement
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
        freeMode: true,
      };
      this.options.speed = 2000; // durée du défilement
    }

    if ('loop' in this.element.dataset) {
      this.options.loop = {
        loop: true,
      };
    }

    if ('slides' in this.element.dataset || this.options.slidesPerView) {
      this.options.slidesPerView = parseFloat(this.element.dataset.slides) || 5;
    }
  }

  init() {
    this.setOptions();
    console.log(this.options);
    new Swiper(this.element, this.options);
    console.log('Initialisation de ma composante Carousel');
  }
}
